import { FC } from 'react';
import {
  Button,
  ButtonGroup,
  Dropdown
} from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileImport,
  faGear,
  faListCheck,
  faTimeline
} from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (entity, title) => void;
  disabled?:boolean;
}

const DropdownButtonImport: FC<IProps> = ({
  onClick,
  disabled
}) => {
  return (
    <Dropdown as={ButtonGroup} >
      <Button variant="primary"
        disabled={disabled || false}
        >
        <FontAwesomeIcon icon={faFileImport} className='me-2' />
        <span>{t("IMPORT")}</span>
      </Button>

      <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" disabled={disabled || false} />

      <Dropdown.Menu>
        <Dropdown.Item className='fw-bold' onClick={() => onClick("equipment", "IMPORTAÇÃO DE DADOS DE EQUIPAMENTOS")} >
          <FontAwesomeIcon icon={faGear} className='me-2' />
          Equipamentos
        </Dropdown.Item>
        <Dropdown.Item className='fw-bold' onClick={() => onClick("equipmentConfig", "IMPORTAÇÃO DE DADOS DE PARÂMETROS")}>
          <FontAwesomeIcon icon={faListCheck} className='me-2' />
          Parâmetros
        </Dropdown.Item>
        <Dropdown.Item className='fw-bold' onClick={() => onClick("equipmentData", "IMPORTAÇÃO DE DADOS DE HISTÓRICO")}>
          <FontAwesomeIcon icon={faTimeline} className='me-2' />
          Históricos
        </Dropdown.Item>
      </Dropdown.Menu>

    </Dropdown >
  );
}

export default DropdownButtonImport;